import { formDataBuilder } from '../core/utils/form-data-builder';
import { caller, urlFactory } from '../core/utils/caller';
import Cookies from 'js-cookie';
import { UnexpectedError } from '../core/helpers/errors';
import { message } from 'antd';
import { authFetchAction } from './auth';

export const submitAction = async (values, dispatch) => {
  const body = formDataBuilder({ values });
  const url = urlFactory('/api/backoffice/token');

  try {
    const response = await caller(url, { method: 'POST', body });

    if (response.ok) {
      const { access_token, expires_in } = await response.json();

      Cookies.remove('access_token');
      Cookies.set('access_token', access_token, { expires: values.rememberMe ? expires_in : undefined });
      dispatch(authFetchAction({ redirect: true }));
    } else {
      UnexpectedError();
    }
  } catch (e) {
    message.error('Məlumatlar yalnış daxil edilib.');
  }
};
